import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth/auth.service';
import { EventsService } from 'src/app/services/events/events.service';

export const MENU_GUARD_KEY = 'menuVisited';

@Injectable({
  providedIn: 'root'
})
export class MenuGuard  {

  constructor(private alertController: AlertController, private authService: AuthService, private translate: TranslateService, private eventService: EventsService) { }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    const isComplete = localStorage.getItem(MENU_GUARD_KEY);
    let user = this.authService.getUser();

    if (user && !(isComplete && (isComplete === 'true'))) {
      localStorage.setItem(MENU_GUARD_KEY, "true");
      this.welcomeMenu();
    }
    return true;
  }

  public welcomeMenu() {
    let title = this.translate.instant("menu.alert.welcomeAlert.title");
    let content = this.translate.instant("menu.alert.welcomeAlert.content");
    this.eventService.publish("disableBackButtonMenu", "menu guard");
    this.alertController
      .create({
        message: `<div><img class="" src="assets/img/onBoardingMenu.svg" alt=""></img></div><div><p class="font-bold rose-icon font-size-20">${title}</p></div><div><p>${content}</p></div>`,
        backdropDismiss: false,
        cssClass: "welcomeMenu",
        animated: true,
        buttons: [
          {
            text: this.translate.instant("menu.alert.welcomeAlert.button"),
            cssClass: "alert-button-custom flex-center",
            role: "cancel",
            handler: () => {
              console.log("Boton back");
              this.eventService.publish("enableBackButtonMenu", "menu guard");
            },
          },
        ],
      })
      .then((res) => {
        res.present();
      });
  }

}
